import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomConfirmDialogService } from 'src/app/services/Non-Master/CustomConfirmDialog.service';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { tItemService } from 'src/app/services/tItem.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { tItemModel } from 'src/app/models/tItemModel';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { AppComponent } from 'src/app/app.component';
import { FormControl } from '@angular/forms';
import { SearchItemIDDialogService } from 'src/app/services/Non-Master/SearchItemIDDialog.service';
import { tMediConvModel, tGRNMediConvModel } from 'src/app/models/tMediConvModel';

import { tMedicineService } from 'src/app/services/tMedicine.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { UnitMediPurchaseService } from 'src/app/services/Unit/UnitMediPurchase.service';
import { UnitMediStockService } from 'src/app/services/Unit/UnitMediStock.service';
import { UnitMediPurchaseModel } from 'src/app/models/UnitMediPurchaseModel';
import { UnitMediStockModel } from 'src/app/models/UnitMediStockModel';


@Component({
  selector: 'app-search-grnmed-dialog',
  templateUrl: './search-grnmed-dialog.component.html',
  styleUrls: ['./search-grnmed-dialog.component.css']
})
export class SearchGRNMedDialogComponent implements OnInit {

  selectedRowIndex: number = -1;

  itemUnitList;


  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private customConfirmDialogService: CustomConfirmDialogService,
    private log: LoggerService,
    private route: ActivatedRoute,
    private tMedicineService: tMedicineService, 
    private unitMediPurchaseService: UnitMediPurchaseService,
    private unitMediStockService: UnitMediStockService,
    ) { }

  displayedColumns: string[] = [

    'mediCode',
   // 'mediCateCode',
    'mediNameAll',
    'mediPurchaseUnit',
    'mediStockUnit',
    'mconvConvQty',
    'mediRemark2'

  ];

  dataSource: MatTableDataSource<tGRNMediConvModel>;
  dataList: tGRNMediConvModel[];


  generalFilter = new FormControl();
  filteredValues = {
    mediCode: '', mediName: '', mediNameEng: '', mediBarCode: '',mediRemark2: ''
  };

  mediPurchaseUnitList : UnitMediPurchaseModel[];
  mediStockUnitList : UnitMediStockModel[];
  mediCateCodeList;



  @ViewChild(MatPaginator) paginator: MatPaginator;

  TAG = 'SearchGRNMedDialogComponent';
  // displayMsg: string;
  @Input() action: string;
  @Input() status: string;
  @Input() tableKeyValue: string;
  @Input() msg: string;
  //adding for booking search service only
  @Input() searchFilter: number;

  ngOnInit() {
    this.setDefaultLanguageString(AppComponent.usingLanguage);

    this.getAllData();
  }

  getAllData(): void {
    this.log.i(this.TAG, 'getAllData searchFilter = ' + this.searchFilter);
    // this.getItemTypeInfo();

    this.tMedicineService.getGRNConvMediCode().subscribe(data => {

      data = data.filter(x => x.mediCateCode === this.searchFilter);

      // if (this.searchFilter !== 4) {
      //   data = data.filter(x => x.mediCateCode === this.searchFilter);
      // }
      data = data.filter(x => x.shopID === NavigationComponent.selectedShopID.toString());


      this.dataList = data;

      this.log.i(this.TAG,"getAllData = "+JSON.stringify(this.dataList));

      this.dataSource = new MatTableDataSource<tGRNMediConvModel>(this.dataList);
      this.dataSource.paginator = this.paginator;

      this.generalFilter.valueChanges.subscribe((generalFilterValue) => {
        this.filteredValues['mediCode'] = generalFilterValue;
        this.filteredValues['mediName'] = generalFilterValue;
        this.filteredValues['mediNameEng'] = generalFilterValue;
        this.filteredValues['mediBarCode'] = generalFilterValue;
        this.filteredValues['mediRemark2'] = generalFilterValue;

        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.dataSource.filterPredicate = this.customFilterPredicate();

    });



  }

  customFilterPredicate() {
    const myFilterPredicate = (data: tGRNMediConvModel, filter: string): boolean => {

      let searchString = JSON.parse(filter);

      return data.mediCode.toString().trim().toLowerCase().indexOf(searchString.mediCode.toLowerCase()) !== -1
        ||
        (searchString.mediName.toLowerCase() == '' ||
          (data.mediName != null
            && data.mediName.toString().trim().toLowerCase().indexOf(searchString.mediName.toLowerCase()) !== -1))
        ||
        (searchString.mediNameEng.toLowerCase() == '' ||
          (data.mediNameEng != null
            && data.mediNameEng.toString().trim().toLowerCase().indexOf(searchString.mediNameEng.toLowerCase()) !== -1))
        ||
        (searchString.mediBarCode.toLowerCase() == '' ||
          (data.mediBarCode != null
            && data.mediBarCode.toString().trim().toLowerCase().indexOf(searchString.mediBarCode.toLowerCase()) !== -1))
        ||
        (searchString.mediRemark2.toLowerCase() === '' ||
          (data.mediRemark2 != null
            && data.mediRemark2.toString().trim().toLowerCase().indexOf(searchString.mediRemark2.toLowerCase()) !== -1))
        ;

    }

    return myFilterPredicate;
  }

  setDefaultLanguageString(language: String) {
    switch (language) {
      case SystemDefaultModel.Language_Chinese:
        this.mediCateCodeList = ChineseDefaultModel.MediCateCodeList;
        break;
      case SystemDefaultModel.Language_English:
        this.mediCateCodeList = EnglishDefaultModel.MediCateCodeList;
        break;
      default:
        this.mediCateCodeList = ChineseDefaultModel.MediCateCodeList;
        break;
    }

    this.unitMediPurchaseService.getActiveDatas().subscribe(data => {
      this.mediPurchaseUnitList = data;
    });


    this.unitMediStockService.getActiveDatas().subscribe(data => {
      this.mediStockUnitList = data;
    });
  }



  selectRow(selectedModel: tGRNMediConvModel, index: number) {

    this.selectedRowIndex = index;

    this.activeModal.close(selectedModel);
  }


  getMediPurchaseUnitListName(id: number) {
    return this.mediPurchaseUnitList.find(p => p.mediPurchaseUnitID === id).purchaseUnitName;
  }


  getMediStockUnitListName(id: number) {
    return this.mediStockUnitList.find(p => p.mediStockUnitID === id).stockUnitName;
  }



}
